let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("DmCr1")).then(() => parcelRequire('ftl82'));